<template>
	<div class="share-icons">
		<!-- FB -->
		<a
			class="share-icon cur-p mr-2"
			target="_blank"
			:href="shareFbUrl"
			v-tooltip="'Share to Facebook'">
			<FacebookIcon
				fillColor="#4267B2"
				:size="36"
			/>
		</a>
		<!-- Twitter -->
		<a
			class="share-icon cur-p text-center d-inline-flex align-items-center justify-content-center"
			target="_blank"
			:href="shareTwitterUrl"
			v-tooltip="'Share to Twitter'">
			<TwitterIcon
				fillColor="#1DA1F2"
				:size="32"
			/>
		</a>
	</div>
</template>

<script>
import FacebookIcon from 'vue-material-design-icons/Facebook.vue';
import TwitterIcon from 'vue-material-design-icons/Twitter.vue';

export default {
	name: 'SocialShare',
	props: {
		url: {
			type: String,
			default: '',
		},
	},
	components: {
		FacebookIcon,
		TwitterIcon,
	},
	computed: {
		shareFbUrl() {
			const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.url)}`;
			return url;
		},
		shareTwitterUrl() {
			// https://twitter.com/intent/tweet?text=TWEET_TO_SHARE&url=URL_TO_SHARE&via=USERNAME_TO_SHARE
			const url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(this.url)}`;
			return url;
		},
	},
};
</script>

<style>

</style>
